import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { HistoryBaseComponent } from 'src/app/history-base/history-base.component';
import { Config } from 'src/infrastructure/config';
import { OrderStatus } from 'src/infrastructure/enums/orderStatus';
import { PaymentMethod } from 'src/infrastructure/enums/paymentMethod';
import { ShipmentType } from 'src/infrastructure/enums/shipmentType';
import { CartLine } from 'src/models/DTO/cart/cartLine';
import { PlainContactV2 } from 'src/models/DTO/contact/plainContactV2';
import { CreatedOrder } from 'src/models/DTO/orders/createdOrder';
import { Organisation } from 'src/models/DTO/organisation/organisation';
import { PaymentIntents } from 'src/models/DTO/paymentIntents/paymentIntents';
import { OrderReturnRequests } from 'src/models/DTO/returns/orderReturnRequests';
import { CreateOrderReturnRequestModel } from 'src/models/requestModels/orders/CreateOrderReturnRequestModel';
import { ImagesService } from 'src/services/request/images/images.service';
import { OrderService } from 'src/services/request/orders/order.service';
import { PartnerService } from 'src/services/request/partner/partner.service';
import { ProductService } from 'src/services/request/product/product.service';
import { OrderReturnServiceService } from 'src/services/request/returns/order-return-service.service';
import { StripeService } from 'src/services/request/stripe/stripe.service';
import { HistoryService } from 'src/services/state/history/history.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-order',
  templateUrl: './order.component.html',
  styleUrls: ['./order.component.css']
})
export class OrderComponent extends HistoryBaseComponent implements OnInit {

  selectedOrder: string = 'Най-нови';
  selectedFilter: string = 'Всички';

  private _order?: CreatedOrder;
  private _paymentIntent?: PaymentIntents;
  private _organisation?: Organisation
  private _orderReturnRequests: OrderReturnRequests = { data: [] };
  private _sorts = {
    newest: "newest",
    oldest: "oldest"
  }

  private _groupType = {
    individual: 'Индивидуална',
    group: 'Групова'
  }

  constructor(

    private partnerService: PartnerService,
    private ordersService: OrderService,
    private imagesService: ImagesService,
    private router: Router,
    private toastrService: ToastrService,
    private activatedRoute: ActivatedRoute,
    private orderReturnService: OrderReturnServiceService,
    private stripeService: StripeService,
    protected location: Location,
    protected historyService: HistoryService,
    private modalService: NgbModal
  ) {
    super(location, historyService);
    this.loadOrderReturns();
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(params => {
      this.loadOrder(params.id);
    });
  }

  private loadOrderReturns(): void {
    this.orderReturnService.getAllOrderReturns(this._sorts.newest).subscribe((returns) => {
      this._orderReturnRequests = returns;
    });
  }

  private loadOrder(orderUUID: string): void {
    this.ordersService.getOrder(orderUUID).subscribe(order => {
      this._order = order;
      console.log('ордер-------->', order);
      this.partnerService.getPartnerInfo(this._order.data.lines[0].sku.product.organisation.uuid).subscribe(partner => {
        this._organisation = partner;
      })
      if (!this.isCOD) {
        if (this._order.data.payment_method_charge_id) {
          this.stripeService.getPaymentIntentDetails(this._order.data.payment_method_charge_id).subscribe(paymentIntent => {
            this._paymentIntent = paymentIntent;
          });
        }
        else {
          this._paymentIntent = {
            charges: {
              data: [
                {
                  payment_method_details: {
                    card: {
                      brand: '',
                      last4: 0
                    }
                  }
                }
              ]
            }
          };
        }

      }
      order.data.lines.findIndex(product => {
        this.imagesService.getImagesForProduct("SKU", product.sku.uuid).subscribe(image => {
          if (image.data.length) {
            product.imageSource = image.data[0]?.original.url || '/assets/images/shared/logo.png';
          }
          else {
            this.imagesService.getImagesForProduct("PRODUCT", product.sku.product.uuid).subscribe(image => {
              product.imageSource = image.data[0]?.original.url || '/assets/images/shared/logo.png';
            });
          }
        });
        // this.productService.getProductInfo(product.uuid).subscribe(productInfo => {
        //   product.product = productInfo
        // })
      });
    });
  }

  private isOrderAlreadyReturned() {
    let orderReturn = this._orderReturnRequests.data.find(returnRequest => returnRequest.order.uuid == this._order?.data.uuid);
    if (orderReturn) {
      return true;
    }
    return false;
  }

  private getCompanyNumberDetails(address: PlainContactV2) {
    let companyInfo = ', ' + address.company_number;
    if (address.company_vat_number) {
      companyInfo += ', ' + address.company_vat_number;
    }
    companyInfo += ', ' + address.company_owner;
    return companyInfo
  }

  get paymentIntent() {
    return this._paymentIntent;
  }

  get order() {
    return this._order;
  }

  get voucherSumAsNumber() {
    return Number.parseFloat(this.order?.data.voucher_amount || '0');
  }

  get orderStatus() {
    if (!this.order?.data.state) {
      return '-';
    }
    return OrderStatus[this.order?.data.state];
  }

  get groupType() {
    return (this._order?.data.group) ? this._groupType.group : this._groupType.individual
  }
  get groupCount(): string {
    return this._order?.data?.group?.participants_count + ' души/' + this._order?.data?.group?.quantity_reserved + ' броя';
  }

  get isCOD() {
    return this._order?.data.paymentMethod.code == PaymentMethod.COD;
  }

  get addressSectionTitle() {
    return (this.order?.data?.delivery_method == ShipmentType.types.toDoor) ? 'Доставка до адрес' : 'Доставка до офис на Speedy';
  }


  get cardImg() {
    if (!this._paymentIntent?.charges.data[0].payment_method_details.card.brand) {
      return '';
    }
    let cardImage = '/assets/images/cards/card-mastercard.svg';
    if (this._paymentIntent?.charges.data[0].payment_method_details.card.brand == "visa") {
      cardImage = '/assets/images/cards/card-visa.svg';
    }
    return cardImage
  }

  get getCardDetail() {
    if (!this._paymentIntent?.charges.data[0].payment_method_details.card.brand) {
      return '-';
    }
    let cardName = "MASTERCARD *";
    if (this._paymentIntent?.charges.data[0].payment_method_details.card.brand == "visa") {
      cardName = "VISA DEBIT *";
    }
    return cardName + this._paymentIntent?.charges.data[0].payment_method_details.card.last4
  }

  get btnStyle() {
    let defalutBtnStyle = "position: relative; bottom: 0px; width: 100%; margin: auto; height: 45px;"
    if (this.isTimeForReturnedAlreadyPassed || this.isOrderAlreadyReturned()) {
      return defalutBtnStyle + " opacity: .45;";
    }
    return defalutBtnStyle;
  }

  get isTimeForReturnedAlreadyPassed() {
    if (!this._order || ! this._organisation) return false;
    if (!this._order!.data.delivered_at) return true;
    let daysToReturn = Number.parseInt(this._organisation!.data.product_max_return_period_in_days);
    const oneDay = 24 * 60 * 60 * 1000;
    const firstDate = new Date();
    const secondDate = new Date(this._order!.data.delivered_at);
    const diffDays = Math.round(Math.abs((firstDate.getTime() - secondDate.getTime()) / oneDay));
    return daysToReturn < diffDays;
  }

  toFixed(input: any) {
    return Number.parseFloat(input).toFixed(2);
  }

  date(date: any) {
    let dateOfOrder = new Date(date)
    return dateOfOrder.toLocaleDateString() + ', ' + dateOfOrder.toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'}) || ''
  }

  status(status: any) {
    return OrderStatus[status];
  }

  goToProduct(productPerOrg: CartLine) {
    if (productPerOrg.sku.product.deleted_at) {
      this.toastrService.info("Продуктът вече не е наличен.");
      return;
    }
    this.router.navigate(['product/' + productPerOrg.sku.product.uuid + '/' + 'none'])
  }
  cancelledProductsModal(content: any): void {
    this.modalService.open(content, { centered: true });
  }
  get cancelledProductsCount(): number {
    if (!this.order?.data?.lines) {
      return 0;
    }
    return this.order.data.lines
      .filter((line: any) => line.initial_quantity !== line.quantity)
      .reduce((total: number, line: any) => {
        return total + (line.initial_quantity - line.quantity);
      }, 0);
  }

  getUnitPriceBase(cartLine: CartLine): number {
    return Number(cartLine.price_per_piece) || 0;
  }

  getLineTotalBase(cartLine: CartLine): number {
    return this.getUnitPriceBase(cartLine) * (Number(cartLine.quantity) || 0);
  }

  getBaseLineTotal(cartLine: CartLine): number {
    const singleNet = Number(cartLine.single_net || '0');
    const vat = Number(cartLine.single_tax_amount || '0');
    const quantity = Number(cartLine.quantity) || 0;

    return (singleNet + vat) * quantity;
  }

  pricingInfoText(cartLine: CartLine): string {
    return `${Number(cartLine.quantity) || 0} x`;
  }

  getCancelledLineTotalBase(cartLine: any): number {
    const cancelledQty = (Number(cartLine.initial_quantity) || 0) - (Number(cartLine.quantity) || 0);
    return this.getUnitPriceBase(cartLine) * cancelledQty;
  }

  pricingCancelledInfoText(cartLine: any): string {
    const cancelledQty = (Number(cartLine.initial_quantity) || 0) - (Number(cartLine.quantity) || 0);
    return `${cancelledQty} x`;
  }

  getSubtotalBase(): number {
    if (this.order?.data?.group) {
      return Number(this.subTotal) || 0;
    }

    return Number(this.order?.data?.total_gross) || 0;
  }

  getShipmentCostBase(): number {
    return Number(this.order?.data?.shipment_cost) || 0;
  }

  getGroupDiscountBase(): number {
    return Number(this.groupDiscount) || 0;
  }

  getOrderGrandTotalBase(): number {
    return Number(this.totalForOrderWithVoucher()) || 0;
  }

  basePrice(cartLine: CartLine): string[]{
    console.log('basePrice ---> cartLine: ', cartLine);
    const singleNet = Number.parseFloat(cartLine.single_net || '0.00');
    const quantity = cartLine.quantity;
    const vat = Number.parseFloat(cartLine.single_tax_amount || '0.00');
    const priceCalculated = (singleNet + vat) * quantity;
    const fixedPrice = priceCalculated.toFixed(2);
    const priceArray = fixedPrice.split('.');
    priceArray[0] = priceArray[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return priceArray;
  }
  get subTotal(): string{
    const total = this.order?.data?.lines.reduce((sum, item) => {
      return sum + (item.single_net && item.quantity && item.single_tax_amount ? (parseFloat(item.single_net) + parseFloat(item.single_tax_amount)) * item.quantity : 0);
    }, 0) as number;
    return total.toFixed(2);
  }
  get groupDiscount(){
    return (parseFloat(this.subTotal) - Number.parseFloat(this.order?.data.total_gross || '0')).toFixed(2);
  }
  pricingInfo(cartLine: CartLine) {
    let price = cartLine.price_per_piece;
    let priceAsString =  Number.parseFloat(price).toFixed(2);
    return  cartLine.quantity + ' x ' + priceAsString + ' лв.';
  }
  shouldShowDiscountPrice(cartLine: CartLine): boolean {
    const singleNet = Number.parseFloat(cartLine.single_net || '0.00');
    const vat = Number.parseFloat(cartLine.single_tax_amount || '0.00');
    const pieces = Number.parseFloat(cartLine.price_per_piece || '0.00');
    return singleNet + vat !== pieces;
  }
  getPriceAsFixedString(cartLine: CartLine) {
    if (!cartLine.price_per_piece) return '00.00';
    let priceCalculated =  Number.parseFloat(cartLine.price_per_piece) * cartLine.quantity
    let fixedPrice = priceCalculated.toFixed(2);
    let priceArray = fixedPrice.split('.');
    priceArray[0] = priceArray[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return priceArray;
  }

  pricingCancelledInfo(cartLine: any): string {
    const price = cartLine.single_net;
    const priceAsString =  Number.parseFloat(price).toFixed(2);
    return  (cartLine.initial_quantity - cartLine.quantity) + ' x ' + priceAsString + ' лв.';
  }

  getCancelledPriceAsFixedString(cartLine: any): string[] {
    const priceCalculated =  Number.parseFloat(cartLine.price_per_piece || '00.00') * (cartLine.initial_quantity - cartLine.quantity);
    const fixedPrice = priceCalculated.toFixed(2);
    const priceArray = fixedPrice.split('.');
    priceArray[0] = priceArray[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return priceArray;
  }

  getTotalPriceAsFixedString(price: string) {
    if (!price) return '00.00';
    let fixedPrice = Number.parseFloat(price).toFixed(2);
    let priceArray = fixedPrice.split('.');
    priceArray[0] = priceArray[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return priceArray[0] + '.' +priceArray[1];
  }

  getAddressName(address: PlainContactV2 | undefined) {
    if (Config.invoiceCompanyLocationRole == address?.type.label) {
      return address.company_name || ''
    }
    return address?.name || '';
  }

  getAddressPhone(address: PlainContactV2 | undefined) {
    if (Config.invoiceCompanyLocationRole == address?.type.label) {
      return this.getCompanyNumberDetails(address);
    }
    return address?.mobile_phone_1_e164;
  }

  getAddressString(address: PlainContactV2 | undefined) {
    if (!address) return '';
    if (Config.invoiceCompanyLocationRole == address.type.label) {
      return address.city + ', ' + address.address_line_2 + ', ' + address.post_code;
    }
    if (Config.userOfficeLocationRole == address.type.label) {
      return address.city + ', ' + address.address_line_2;
    }
    return address.street_name + ' '
            + address.street_number + ', '
            + ((address.address_line_2) ? (address.address_line_2 + ', ') : '')
            + address.city + ', '
            + ((address.post_code) ? address.post_code : '')
  }

  return() {
    if (this.isTimeForReturnedAlreadyPassed) {
      this.toastrService.warning("Изтекъл е възможният срок за връщане на продукт.")
      return;
    }
    if (this.isOrderAlreadyReturned()) {
      this.toastrService.warning("Вече има пусната заявка за връщане за поръчката.");
      return
    }
    this.router.navigate(['return/choose/' + this.order?.data.uuid]);
  }

  public deliveryForCartLineAsString(shipmentCost: string) {
    return Number.parseFloat(shipmentCost).toFixed(2)
  }

  returnOptionValue(option: any) {
    if (option.option.values.length) {
      let optionSelected = option.option.values.find((value: { uuid: any; }) => value.uuid == option.value);
      return optionSelected.value;
    }
    return option.value;
  }

  totalForOrderWithVoucher() {
    return (Number.parseFloat(this.order?.data.total_gross || '0') + Number.parseFloat(this.order?.data.shipment_cost  || '0') - Number.parseFloat(this.order?.data.voucher_amount || '0')).toFixed(2);
  }

}
